import { Connector, ConnectorResult, ConnectorResults } from '@mathquis/modelx';
import Sift from 'sift';
import { v4 as UUID } from 'uuid';
export class WebStorageConnector extends Connector {
    initialize(options) {
        if (!this.isAvailable())
            throw new Error('LocalStorage is not available');
    }
    list(collection, options = {}) {
        return new Promise((resolve) => {
            // Filters
            const filters = options.filters ? Sift(options.filters) : null;
            // Pagination
            const offset = options.offset || 0;
            const limit = options.limit || 0;
            const max = options.max || this.options.max || 0;
            const items = [];
            const keys = [];
            let processed = 0;
            let found = 0;
            const numItems = this.getStorage().length;
            for (let index = 0; index < numItems; index++) {
                // Get the key
                const key = this.getStorage().key(index);
                // Not the correct path
                if (key.indexOf(collection.path) < 0)
                    continue;
                // Increase processed counter
                processed++;
                if (max > 0 && processed > max)
                    break;
                const value = this.decode(this.getStorage().getItem(key));
                if (filters && !filters(value))
                    continue;
                found++;
                if (found - 1 < offset)
                    continue;
                if (limit && found > offset + limit)
                    continue;
                items.push(value);
                keys.push(key);
            }
            resolve(new ConnectorResults(items, { processed, found, offset, limit, max, keys }));
        });
    }
    fetch(model, options = {}) {
        return new Promise((resolve) => {
            const key = this.getKey(model.path);
            const value = this.getStorage().getItem(key);
            if (!value) {
                throw new Error('Model [' + key + '] not found');
            }
            resolve(new ConnectorResult(this.decode(value)));
        });
    }
    save(model, options = {}) {
        return new Promise((resolve) => {
            if (!model.id)
                model.setId(this.generateId(model));
            const key = this.getKey(model.path);
            const value = model.untransformedAttributes;
            this.getStorage().setItem(key, this.encode(value));
            resolve(new ConnectorResult(value));
        });
    }
    destroy(model, options = {}) {
        return new Promise((resolve) => {
            const key = this.getKey(model.path);
            this.getStorage().removeItem(key);
            resolve(new ConnectorResult(model.untransformedAttributes));
        });
    }
    getStorage() {
        return this.options.storage;
    }
    setStorage(storage) {
        this.options.storage = storage;
        return this;
    }
    getKey(path) {
        return (this.options.prefix || '') + path;
    }
    generateId(model) {
        return this.options.id ? this.options.id(model) : UUID();
    }
    isAvailable() {
        const test = 'test';
        try {
            this.getStorage().setItem(test, test);
            this.getStorage().removeItem(test);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    encode(value) {
        return (this.options.encoder || JSON.stringify)(value);
    }
    decode(value) {
        return (this.options.decoder || JSON.parse)(value);
    }
}
//# sourceMappingURL=index.js.map